import { TRANSPORT } from 'helpers/routes';
import { FREIGHTS } from 'helpers/routes';
import { TemplateMapConfig, TemplateMapVariant } from './types';

export const getTemplateMapConfig = (variant: TemplateMapVariant): TemplateMapConfig => {
  if (variant === 'transport') {
    return {
      variant: 'transport',
      translations: {
        back: 'transportSearch.back',
        templateMap: 'transportSearch.templateMap',
        loadingRadius: 'transportSearch.loadingRadius',
        unloadingRadius: 'transportSearch.unloadingRadius',
        dateFrom: 'transportSearch.dateFrom',
        dateTo: 'transportSearch.dateTo',
        refresh: 'transportSearch.refresh',
        itemsFound: 'transportSearch.transportsFound',
        noItemName: 'transport.noName',
      },
      routes: {
        search: TRANSPORT.search,
      },
      itemIdParam: 'transportId',
      dateFields: {
        from: 'available_from',
        to: 'available_to',
      },
    };
  }

  return {
    variant: 'freight',
    translations: {
      back: 'freightSearch.back',
      templateMap: 'freightSearch.templateMap',
      loadingRadius: 'freightSearch.loadingRadius',
      unloadingRadius: 'freightSearch.unloadingRadius',
      dateFrom: 'freightSearch.dateFrom',
      dateTo: 'freightSearch.dateTo',
      refresh: 'freightSearch.refresh',
      itemsFound: 'freightSearch.freightsFound',
      noItemName: 'freight.noName',
    },
    routes: {
      search: FREIGHTS.search,
    },
    itemIdParam: 'cargoId',
    dateFields: {
      from: 'loading_from',
      to: 'loading_to',
    },
  };
};
